module.exports = __webpack_public_path__ + "img/about_join_1.05212ea0.png";